// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bars[data-v-b5de6e4e] {\r\n\tcolor: var(--main-gray-5);\n}\n.bars[data-v-b5de6e4e]:hover {\r\n\tcolor: var(--main-blue-3);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
